import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { useCallback, useMemo } from 'react';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { customAccessFunction } from '../common/access';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from '../common/hooks';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useEnvironmentalAspect(): IssueChartContext {
  const processesWithEnvAspect = useProcessesWithField(
    IssueFieldNames.environmentalAspect
  );
  const access = useCallback(() => {
    return Boolean(processesWithEnvAspect.length);
  }, [processesWithEnvAspect]);
  const filters = useIssueChartFilters({ chart: IssueChart.environmentalAspect, processes: processesWithEnvAspect });
  const additionalParams = useMemo(
    () => ({
      visibleProcesses: processesWithEnvAspect.map(
        (process) => process._id
      ),
    }),
    [processesWithEnvAspect]
  );
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.environmentalAspect, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.aspectChart,
    chartType: ChartType.donut,
    canAccess: customAccessFunction(access),
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
